import { render } from "./LatestInterventions.vue?vue&type=template&id=f4718814"
import script from "./LatestInterventions.vue?vue&type=script&lang=js"
export * from "./LatestInterventions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rizome.dvit.cloud/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__